






import Vue from 'vue';
import { HttpService } from '@/services/http-service';
import store from '@/store';
import router from './router';

export default Vue.extend({
    created: function() {
        /**
         * После создания компонента, прописываем перехват http запросов.
         * Если обнаруживаем код 401, то есть потерю аутентификации,
         * то так же осуществляет выход на стороне фронтэнда
         */
        HttpService.interceptors.response.use(undefined, function(err) {
            return new Promise(function(resolve, reject) {
                if (err.message.indexOf('code 401', 0) !== -1) {
                    store.dispatch('auth/cleanAuth').then(() => {
                        router.push('/auth');
                    });
                }
                console.log(err);
                throw err;
            });
        });
    }
});
